import { render, staticRenderFns } from "./DispensationApplications.vue?vue&type=template&id=2ab74bb0&scoped=true&"
import script from "./DispensationApplications.vue?vue&type=script&lang=js&"
export * from "./DispensationApplications.vue?vue&type=script&lang=js&"
import style0 from "./DispensationApplications.vue?vue&type=style&index=0&id=2ab74bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab74bb0",
  null
  
)

export default component.exports